import React from 'react'

import Form from '../components/Form/Form';

const SignupPage = () => {
  return (
    <div>

<Form />
    </div>
  )
}

export default SignupPage